import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { DataSetDataProvider } from "../../data-provider/data-set.dp";

let DataSetAnonymiseDialogComponent = {
    selector: "vcDataSetAnonymiseDialog",
    templateUrl:
        "/angular/components/data-set/data-set-anonymize-dialog.component.html",
    bindings: {},
    controller: class DataSetAnonymiseDialogController {
        private dialog: DialogUtils;
        private dataProvider: DataSetDataProvider;

        public pagination: number = 1;
        public consentedType: boolean = false;
        public loading: boolean = true;
        public link: string;
        public anonymisationInfo: object;
        public __env: any;

        constructor(
            DialogUtils: DialogUtils,
            DataSetDataProvider: DataSetDataProvider,
            __env: any
        ) {
            this.__env = __env;
            this.dialog = DialogUtils;
            this.dataProvider = DataSetDataProvider;
            this.link = this.__env.anonymization_link;
        }

        $onInit() {
            this.consentedPeople(this.consentedType);
        }

        consentedPeople(consentedType: boolean): void {
            this.loading = true;
            this.dataProvider.info(consentedType).then((info: object) => {
                this.anonymisationInfo = info;
                this.loading = false;
            });
        }

        left(): void {
            if (this.pagination === 2) {
                this.pagination = 1;
            } else {
                this.cancel();
            }
        }

        right(): void {
            if (this.pagination === 1) {
                this.pagination = 2;
            } else {
                this.dialog.hide({
                    consentedType: this.consentedType,
                    status: "confirm",
                });
            }
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("dataset", [])
    .component(
        DataSetAnonymiseDialogComponent.selector,
        DataSetAnonymiseDialogComponent
    );
